<template>
  <div>
    <v-select
      v-model="selectedDateFilter"
      :items="dateFilters"
      @change="handleDateChange"
      v-bind="selectProps"
    >
      <template v-if="showDatePicker" #selection>
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="customDateRange"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template #activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="flex">
              <v-icon>mdi-calendar</v-icon>
              <span>{{ dateRangeText }}</span>
            </div>
          </template>
          <v-date-picker v-model="customDateRange" range no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false">
              Cancelar
            </v-btn>
            <v-btn text color="primary" @click="handleCustomDate">
              Aceptar
            </v-btn>
          </v-date-picker>
        </v-menu>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: "MetricsDateRange",

  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    default: {
      type: String,
      default: "Todas"
    },
    dense: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "Selecciona un filtro de fecha"
    },
    variant: {
      type: String,
      default: "outlined"
    }
  },

  data() {
    return {
      selectedDateFilter: this.default,
      menu: false,
      dateRangeText: "",
      customDateRange: [],
      dateFilters: [
        "Todas",
        "Ayer",
        "Hoy",
        "Últimos 7 días",
        "Últimos 30 días",
        "Mes pasado",
        "Este mes",
        "Año actual",
        "Personalizado"
      ]
    };
  },

  computed: {
    showDatePicker() {
      return this.selectedDateFilter === "Personalizado";
    },
    selectProps() {
      return {
        label: this.label,
        [this.variant]: true,
        dense: this.dense,
        hideDetails: true
      };
    }
  },

  mounted() {
    this.handleDateChange();
  },

  methods: {
    handleDateChange() {
      const today = new Date();
      const y = today.getFullYear();
      const m = today.getMonth();
      const d = today.getDate();
      let startDate, endDate;

      switch (this.selectedDateFilter) {
        case "Ayer":
          startDate = new Date(y, m, d - 1);
          endDate = new Date(y, m, d - 1);
          break;
        case "Hoy":
          startDate = new Date(y, m, d);
          endDate = new Date(y, m, d);
          break;
        case "Últimos 7 días":
          startDate = new Date(y, m, d - 7);
          endDate = new Date(y, m, d);
          break;
        case "Últimos 30 días":
          startDate = new Date(y, m, d - 30);
          endDate = new Date(y, m, d);
          break;
        case "Mes pasado":
          startDate = new Date(y, m - 1, 1);
          endDate = new Date(y, m, 0);
          break;
        case "Este mes":
          startDate = new Date(y, m, 1);
          endDate = new Date(y, m + 1, 0);
          break;
        case "Año actual":
          startDate = new Date(y, 0, 1);
          endDate = new Date(y, 11, 31);
          break;
        case "Personalizado":
          return;
        case "Todas":
        default:
          this.$emit("input", { start: "", end: "" });
          return;
      }

      this.applyDateRange(startDate, endDate);
    },

    handleCustomDate() {
      this.menu = false;
      if (this.customDateRange.length === 2) {
        const [a, b] = this.customDateRange.slice().sort();
        this.applyDateRange(
          new Date(a + "T00:00:00"),
          new Date(b + "T00:00:00")
        );
      }
    },

    applyDateRange(start, end) {
      const startISO = this.localDateToISO(start);
      const endISO = this.localDateToISO(end);
      this.dateRangeText = `${this.formatShortDate(
        start
      )} - ${this.formatShortDate(end)}`;
      this.$emit("input", { start: startISO, end: endISO });
    },

    localDateToISO(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },

    formatShortDate(date) {
      const d = String(date.getDate()).padStart(2, "0");
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const y = date.getFullYear();
      return `${d}/${m}/${y}`;
    },

    resetDateRange() {
      this.selectedDateFilter = this.default;
      this.dateRangeText = "";
      this.menu = false;
      this.customDateRange = [];
      this.handleDateChange();
    }
  }
};
</script>
